module.exports = __webpack_public_path__ + "img/6-2.84a4481f.jpg";